import { render } from "./HouseShop.vue?vue&type=template&id=713540c5"
import script from "./HouseShop.vue?vue&type=script&lang=js"
export * from "./HouseShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__